export const PROCESSINGS_MIN_ZOOM = 12
export const PROCESSINGS_MAX_ZOOM = 21

export const BASE_MIN_ZOOM = 2
export const BASE_MAX_ZOOM = 21

export const FEATURE_GROUPS = {
  BASE_MAP: "BASE_MAP",
  PROCESSINGS: "processings",
  FEATURES: "features",
  POST_PROCESSINGS_RESULTS: "post_processings_results",
}

export const PANES = {
  BASE_MAP: "base_map",
  PROCESSINGS: "processings",
  FEATURES: "features",
  POST_PROCESSINGS_RESULTS: "post_processings_results",
}

export const PANES_OPTIONS = {
  [PANES.BASE_MAP]: {
    style: {
      zIndex: 200,
    },
  },
  [PANES.PROCESSINGS]: {
    style: {
      zIndex: 300,
    },
  },
  [PANES.FEATURES]: {
    style: {
      zIndex: 500,
    },
  },
  [PANES.POST_PROCESSINGS_RESULTS]: {
    style: {
      zIndex: 500,
    },
  },
}
